
import { Base } from '../base-component';
import './share-icons-left.component.scss';

export class ShareIconsLeft extends Base {

	emailButton: Element;
	facebookButton: Element;
	twitterButton: Element;
	linkedinButton: Element;
	whatsButton: Element;

	shareUrl: string;
	shareTitle: string;
	shareDescription: string;
	shareImage: string;

	emailLink: string;
	facebookLink: string;
	twitterLink: string;
	linkedinLink: string;
	whatsApp: string;

	constructor(element: Element) {
		super(element);
	}

	init() {

		this.emailButton = this.element.querySelector('.js-share-mail');
		this.facebookButton = this.element.querySelector('.js-share-facebook');
		this.twitterButton = this.element.querySelector('.js-share-twitter');
		this.linkedinButton = this.element.querySelector('.js-share-linkedin');		
		this.whatsButton = this.element.querySelector('.js-share-whatsapp');

		this.shareUrl = encodeURIComponent(document.URL);
		this.shareTitle = '';
		this.shareDescription = '';
		this.shareImage = '';

		this.setShareLinks();


    }
    
    bindEvents() {

		if(this.facebookButton){
			this.facebookButton.addEventListener('click', (event)=>{
	
				let element;
				if(event.currentTarget){
					element = event.currentTarget;
				}else{
					element = event.target;
				}
	
				let data = element.getAttribute('data-social');
				this.newPopup(data, 'Standard Bank')
	
			})
		}

		if(this.twitterButton){
			this.twitterButton.addEventListener('click', (event)=>{
				
				let element;
				if(event.currentTarget){
					element = event.currentTarget;
				}else{
					element = event.target;
				}
	
				let data = element.getAttribute('data-social');
				this.newPopup(data, 'Standard Bank')
	
			})
		}

		if(this.linkedinButton){
			this.linkedinButton.addEventListener('click', (event)=>{
				
				let element;
				if(event.currentTarget){
					element = event.currentTarget;
				}else{
					element = event.target;
				}
	
				let data = element.getAttribute('data-social');
				this.newPopup(data, 'Standard Bank')
	
			})
		}

		if(this.whatsButton){
			this.whatsButton.addEventListener('click', (event)=>{
				
				let element;
				if(event.currentTarget){
					element = event.currentTarget;
				}else{
					element = event.target;
				}
	
				let data = element.getAttribute('data-social');
				this.newPopup(data, 'Standard Bank')
	
			})
		}
		window.addEventListener('resize', (event)=>{

			let windowWidth = window.screen.width;
			if(windowWidth > 767) {
				this.whatsButton.setAttribute(
					'data-social',
					`https://web.whatsapp.com/send?text=${this.shareDescription}&url=${this.shareUrl}`
				);
			}else{
				this.whatsButton.setAttribute(
					'data-social',
					`whatsapp://send?text=${this.shareDescription}&url=${this.shareUrl}`
				);
			}

		})

    }
    
	getShareMeta(meta) {

		let ogAttribute = document.querySelector(`meta[property='og:${meta}']`);

		if (ogAttribute) {
			return encodeURIComponent(ogAttribute.getAttribute('content'));
		}

		return '';

	}

	setShareMeta() {
		this.shareTitle = this.getShareMeta('title');
		this.shareDescription = this.getShareMeta('description');
		this.shareImage = this.getShareMeta('image');
	}

	setShareLinks() {

		this.setShareMeta();

		setTimeout(() => {

			this.emailButton.setAttribute(
				'href',
				`mailto:?subject=${this.shareTitle}&body=${this.shareDescription} - ${this.shareUrl}`
			);

			this.facebookButton.setAttribute(
				'data-social',
				`https://www.facebook.com/dialog/share?app_id=363419304366429&display=popup&href=${this.shareUrl}&redirect_uri=${this.shareUrl}`
			);

			this.twitterButton.setAttribute(
				'data-social',
				`https://twitter.com/intent/tweet?url=${this.shareUrl}&text=${this.shareDescription}`
			);

			this.linkedinButton.setAttribute(
				'data-social',
				`https://www.linkedin.com/shareArticle?mini=true&url=${this.shareUrl}`
			);

			let windowWidth = window.screen.width;
			if(windowWidth > 767) {
				this.whatsButton.setAttribute(
					'data-social',
					`https://web.whatsapp.com/send?text=${this.shareDescription}&url=${this.shareUrl}`
				);
			}else{
				this.whatsButton.setAttribute(
					'data-social',
					`whatsapp://send?text=${this.shareDescription}&url=${this.shareUrl}`
				);
			}
			

		}, 200);

	}

	newPopup(url, windowName) {

		window.open(url,windowName,'height=500,width=500,left=10,top=10,titlebar=no,toolbar=no,menubar=no,location=no,directories=no,status=no');

	}
	

}



// WEBPACK FOOTER //
// ./components/share-icons-left/share-icons-left.component.ts